// extracted by mini-css-extract-plugin
module.exports = {"container":"_2o5qb4Vg7vIXv7dzHTU9","add-teams-form":"mJt4pYtGmNVguP11wDiO","select":"_1wRQAv5c7PEFE7x54oHT","show-selection-button":"_1KL-xbcJBjDihaljKCrn"};